import React from 'react';
import {
    Button,
    CircularProgress,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    withStyles
} from "material-ui";
import {connect} from "react-redux";
import {Companies} from "../../components/companies";
import {Add, Delete, Edit} from "material-ui-icons";
import {UserDialog} from "./dialog";
import {clearUsers, closeGetUsersFetch, getUsers, setEditUser} from "../../redux/actions/users";
import {UserDeleteDialog} from "./dialog/delete";

export class UserComponent extends React.Component {

    state = {
        dialogOpen: false,
        dialogDeleteOpen: false,
    };

    componentDidMount = () => {
        document.title = 'ユーザー | 三島事務所';
        this.props.initialize();

        if (!this.props.currentUser.is_admin) {
            this.props.getUsers(this.props.currentUser.company_id);
        }
    };

    /**
     * 会社選択
     * @param company
     */
    onCompanySelect = (company) => {
        this.props.getUsers(company.id);
    };

    /**
     * ダイアログを開く
     */
    dialogOpen = () => {
        this.setState({dialogOpen: true});
    };

    /**
     * ダイアログを閉じる
     */
    dialogClose = () => {
        this.setState({dialogOpen: false});
        this.props.getUsers(this.props.activeCompanyId);
        setTimeout(() => {
            this.props.setEditUser({});
        }, 200);
    };

    /**
     * ユーザー情報編集
     * @param user
     */
    onUserEdit = (user) => {
        this.props.setEditUser(user);
        this.dialogOpen();
    };

    onUserDeleteEdit = (user) => {
        this.props.setEditUser(user);
        this.dialogDeleteOpen();
    };

    dialogDeleteOpen = () => {
        this.setState({dialogDeleteOpen: true});
    };

    dialogDeleteClose = () => {
        this.setState({dialogDeleteOpen: false});
        this.props.getUsers(this.props.activeCompanyId);
        setTimeout(() => {
            this.props.setEditUser({});
        }, 200);
    };

    render() {

        const {classes, currentUser, isGetUsersFetch, users} = this.props;
        const {dialogOpen, dialogDeleteOpen} = this.state;

        return (
            <div className={classes.root}>
                {currentUser.is_admin ?
                    <Companies
                        onCompanySelect={this.onCompanySelect}
                        isNewItem={false}/>
                    : null}

                <Paper className={classes.mainContainer}>
                    {!isGetUsersFetch && users.length === 0 ? 'ユーザーが登録されていません' :
                        <div>
                            {isGetUsersFetch ? <CircularProgress/> :

                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>メールアドレス</TableCell>
                                            <TableCell>氏名</TableCell>
                                            <TableCell className={classes.actionCell}>アクション</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {users.map(n => {
                                            return <TableRow key={n.id}>
                                                <TableCell>{n.email}</TableCell>
                                                <TableCell>{n.name}</TableCell>
                                                <TableCell>
                                                    <IconButton
                                                        onClick={this.onUserEdit.bind(this, n)}><Edit/></IconButton>

                                                    <IconButton
                                                        onClick={this.onUserDeleteEdit.bind(this, n)}
                                                        disabled={currentUser.id === n.id}><Delete/></IconButton>

                                                </TableCell>
                                            </TableRow>
                                        })}
                                    </TableBody>
                                </Table>

                            }
                        </div>
                    }

                    <Button variant="fab"
                            color="primary"
                            onClick={this.dialogOpen}
                            className={classes.fabButton}>
                        <Add/>
                    </Button>

                </Paper>

                <UserDialog
                    handleClose={this.dialogClose}
                    open={dialogOpen}/>

                <UserDeleteDialog
                    open={dialogDeleteOpen}
                    handleClose={this.dialogDeleteClose}/>

            </div>
        )
    }
}

const styles = theme => ({
    root: {
        display: 'flex',
        height: 'calc(100vh - 64px)',
        position: 'relative',
    },
    mainContainer: {
        paddingTop: 4,
        background: '#fbfbfb',
        zIndex: 1,
        width: '100%',
        position: 'relative',
        overflow: 'auto',
    },
    fabButton: {
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
    actionCell: {
        width: 170,
    }
});

UserComponent = withStyles(styles)(UserComponent);

UserComponent = connect(
    (state) => {
        return {
            currentUser: state.users.currentUser,
            users: state.users.users,
            isGetUsersFetch: state.users.isGetUsersFetch,
            activeCompanyId: state.app.activeCompanyId,
        }
    },
    (dispatch) => {
        return {
            initialize: () => {
                dispatch(clearUsers());
            },
            getUsers: (companyId) => {
                dispatch(getUsers(companyId)).then(() => {
                    setTimeout(() => {
                        dispatch(closeGetUsersFetch());
                    }, 300);
                });
            },
            setEditUser: (user) => {
                dispatch(setEditUser(user));
            },
        }
    }
)(UserComponent);


// WEBPACK FOOTER //
// ./src/containers/user/index.js